export default __webpack_public_path__ + "static/media/no-eye.ecd0060a.svg";